/* ettitude: live Yotpo totals with the existing compact product-card styling. */
(() => {
  'use strict';
  if (window.ettitudeYotpoCardRatings) return;
  window.ettitudeYotpoCardRatings = true;
  const appKey = 'GV5IZZl55LqmMmpsVRr6Kymy3ZNbe5UqRlw1wsoA';
  const selector = '[data-yotpo-card-rating]';
  const cache = new Map();
  const queue = [];
  let active = 0;

  function pump() {
    while (active < 4 && queue.length) {
      active++;
      const task = queue.shift();
      task().finally(() => { active--; pump(); });
    }
  }

  function bottomline(id) {
    if (cache.has(id)) return cache.get(id);
    const key = `ettitude:yotpo:bottomline:v1:${id}`;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (saved && Date.now() - saved.time < 300000) {
        const result = Promise.resolve(saved.data);
        cache.set(id, result);
        return result;
      }
    } catch (_) { /* Storage is optional. */ }
    const result = new Promise((resolve, reject) => {
      queue.push(async () => {
        try {
          const response = await fetch(`https://api.yotpo.com/products/${appKey}/${id}/bottomline`, {
            credentials: 'omit', signal: AbortSignal.timeout(8000)
          });
          if (!response.ok) throw new Error(`Yotpo HTTP ${response.status}`);
          const json = await response.json();
          const data = json.response && json.response.bottomline;
          if (!data || !Number.isFinite(Number(data.average_score)) ||
              !Number.isInteger(Number(data.total_reviews)) || Number(data.total_reviews) < 0) {
            throw new Error('Invalid Yotpo rating response');
          }
          try { sessionStorage.setItem(key, JSON.stringify({time: Date.now(), data})); } catch (_) {}
          resolve(data);
        } catch (error) {
          cache.delete(id);
          reject(error);
        }
      });
    });
    cache.set(id, result);
    pump();
    return result;
  }

  function currentProductId(element) {
    const card = element.closest('.product-item');
    if (!card) return element.dataset.yotpoProductId;
    const link = card.querySelector('.product-link[href]');
    if (link) {
      const path = new URL(link.href, location.origin).pathname.split('/products/')[1];
      for (const swatch of card.querySelectorAll('[data-sibling-link][data-yotpo-product-id]')) {
        const siblingPath = new URL(swatch.dataset.siblingLink, location.origin).pathname.split('/products/')[1];
        if (path && path === siblingPath) return swatch.dataset.yotpoProductId;
      }
    }
    return element.dataset.yotpoProductId;
  }

  async function update(element) {
    const id = currentProductId(element);
    if (!/^\d+$/.test(id || '') || element.dataset.yotpoRequestedId === id) return;
    element.dataset.yotpoRequestedId = id;
    element.style.display = 'none';
    try {
      const data = await bottomline(id);
      if (!element.isConnected || element.dataset.yotpoRequestedId !== id) return;
      const score = Number(data.average_score);
      const count = Number(data.total_reviews);
      if (score <= 0 || count <= 0) return;
      const display = score.toFixed(1);
      element.querySelector('.kl-rating__value').textContent = display;
      element.querySelector('.kl-rating__count').textContent = `(${count.toLocaleString('en-US')})`;
      element.setAttribute('aria-label', `Rated ${display} out of 5, ${count} reviews`);
      element.dataset.yotpoLoadedId = id;
      element.style.display = 'inline-flex';
    } catch (error) {
      // Never substitute stale legacy ratings or show zero-review stars.
      console.warn('Yotpo product-card rating unavailable', id, error.message);
      delete element.dataset.yotpoRequestedId;
    }
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  }

  function init() {
    scan(document);
    new MutationObserver((records) => {
      const cards = new Set();
      for (const record of records) {
        if (record.type === 'attributes') {
          const card = record.target.closest('.product-item');
          if (card) cards.add(card);
        } else {
          record.addedNodes.forEach(scan);
        }
      }
      cards.forEach(scan);
    }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
